import { GLOBAL } from '@lumapps/translations';

import { LUMAPPS_APPLICATIONS } from './keys';
import type { ApplicationType, ProfileClaim, Scope } from './types';

export const LUMAPPS_APPLICATION_IDENTITY_FEATURE_TOKEN = 'lumapps-application-identity';

/** Application type discriminators — mirror the `ApplicationType` union in `types.ts`. */
export const APPLICATION_TYPE = {
    CLIENT_CREDENTIALS: 'client_credentials',
    LUMAPPS_IDENTITY: 'lumapps_identity',
    AUTHORIZATION_CODE: 'authorization_code',
} as const satisfies Record<string, ApplicationType>;

export const PROFILE_CLAIM_OPTIONS: ProfileClaim[] = [
    'first_name',
    'last_name',
    'email',
    'employee_id',
    'date_of_birth',
];

export const SCOPE_OPTIONS: Scope[] = ['all.admin', 'all.read'];

export const PROFILE_CLAIM_LABEL_KEYS: Record<ProfileClaim, string> = {
    first_name: GLOBAL.FIRST_NAME,
    last_name: GLOBAL.LAST_NAME,
    email: GLOBAL.EMAIL,
    employee_id: LUMAPPS_APPLICATIONS.PROFILE_FIELD_EMPLOYEE_ID,
    date_of_birth: LUMAPPS_APPLICATIONS.DATE_OF_BIRTH,
};

/** Attribute names that are reserved by JWT/IANA standards and cannot be used as custom claim names. */
export const BLOCKED_ATTRIBUTE_NAMES = new Set([
    'sub',
    'iss',
    'jti',
    'iat',
    'nbf',
    'exp',
    'aud',
    'scope',
    'organizationId',
    'employeeId',
    'firstName',
    'lastName',
    'email',
]);
